import Subright from "../Subright";
import store from "../../store/configureStore";

class SubrightBuilder {
  static buildSubright(
    rightsCategoryID,
    descriptionHash,
    id,
    learnMores,
    organizations,
    titleHash
  ) {
    if (
      rightsCategoryID == null ||
      descriptionHash == null ||
      id == null ||
      titleHash == null
    ) {
      return null;
    }

    if (
      typeof rightsCategoryID !== "string" ||
      typeof descriptionHash !== "string" ||
      typeof id !== "string" ||
      typeof titleHash !== "string"
    ) {
      return null;
    }

    const translationMap = store.getState().rights.translationMap;
    if (
      !translationMap.hasOwnProperty(descriptionHash) ||
      !translationMap.hasOwnProperty(titleHash)
    ) {
      return null;
    }

    const learnMoreArr = learnMores ? learnMores : [];
    const organizationsArr = organizations ? organizations : [];
    const description = translationMap[descriptionHash];
    const title = translationMap[titleHash];

    return new Subright(
      rightsCategoryID,
      description,
      descriptionHash,
      id,
      learnMoreArr,
      organizationsArr,
      title,
      titleHash
    );
  }
}

export default SubrightBuilder;
